import React from 'react';

import classNames from 'classnames';

import styles from './primary-button.less';

type PrimaryButtonProps = React.HTMLProps<HTMLButtonElement>;

const PrimaryButton = ({ className = '', ...props }: PrimaryButtonProps) => (
  <button className={classNames(styles.primaryButton, className)} {...props} />
);

export default PrimaryButton;



// WEBPACK FOOTER //
// ./app/gamma/src/components/buttons/primary-button/index.tsx